import clsx from 'clsx';
import React from 'react';

type TogglePillProps = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  size?: 'default' | 'large';
  variant?: 'default' | 'inverted';
  disabled?: boolean;
};

export const TogglePill: React.FC<TogglePillProps> = ({
  label,
  isActive,
  onClick,
  size = 'default',
  variant = 'default',
  disabled = false,
}) => {
  const isLarge = size === 'large';
  const isInverted = variant === 'inverted';

  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={clsx(
        'flex items-center justify-center gap-2.5 px-5 rounded-3xl',
        isLarge ? 'h-16 py-0' : 'h-auto py-3',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        isActive ? (isInverted ? 'bg-[#F4F4F4]' : 'bg-white') : 'bg-transparent'
      )}
    >
      <div
        className={clsx(
          'text-center font-medium break-words',
          isLarge ? 'text-xl' : 'text-sm',
          isActive ? 'text-black' : 'text-[#B2B2B2]'
        )}
      >
        {label}
      </div>
    </div>
  );
};
